var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form__element radio-list radio-list--inline"},[_vm._l((_vm.options),function(option,key){return _c('v-radio',{key:'radio_' + key + '_opt',attrs:{"name":_vm.name,"required":_vm.name && _vm.required,"label":option.label,"value":option.value}})}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }